"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.map.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./style/index");

var _excluded = ["panes"];

var _this = void 0;

var paneShape = {
  /** tab的唯一key */
  key: _propTypes["default"].string,

  /** tab的title内容 */
  tab: _propTypes["default"].node,

  /** 是否强制渲染 */
  forceRender: _propTypes["default"].bool,

  /** 是否禁用 */
  disabled: _propTypes["default"].bool,

  /** 面板的内容 */
  content: _propTypes["default"].node
};
/**
 * ProductLayout.Tabs
 * @description 产品切换Tabs
 */

var Tabs = function Tabs(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var panes = _ref.panes,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var renderPanes = function renderPanes() {
    var _this3 = this;

    (0, _newArrowCheck2["default"])(this, _this2);

    if (!(0, _isArray2["default"])(panes)) {
      return null;
    }

    return panes.map(function (pane) {
      (0, _newArrowCheck2["default"])(this, _this3);
      var key = pane.key,
          tab = pane.tab,
          forceRender = pane.forceRender,
          disabled = pane.disabled,
          content = pane.content;
      return /*#__PURE__*/_react["default"].createElement(_index.StyledTabsPane, {
        tab: /*#__PURE__*/_react["default"].createElement("span", null, tab, /*#__PURE__*/_react["default"].createElement("span", {
          className: "uc-tabs__item-corner uc-tabs__item-corner--left"
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "uc-tabs__item-corner uc-tabs__item-corner--right"
        })),
        key: key,
        forceRender: forceRender,
        disabled: disabled
      }, content);
    }.bind(this));
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_index.StyledTabs, (0, _extends2["default"])({
    tabBarPosition: "top",
    styleType: "pure",
    size: "sm"
  }, others), renderPanes());
}.bind(void 0);

Tabs.propTypes = {
  /** 当前激活的tab key，受控 */
  activeKey: _propTypes["default"].string,

  /** 默认激活的tab key，非受控 */
  defaultActiveKey: _propTypes["default"].string,

  /** tab修改时的回调 */
  onChange: _propTypes["default"].func,

  /** 是否销毁不展示的tab内容 */
  destroyInactiveTabPane: _propTypes["default"].bool,

  /** tabs的面板 */
  panes: _propTypes["default"].arrayOf(_propTypes["default"].shape(paneShape))
};
Tabs.defaultProps = {};
var _default = Tabs;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProductLayout/Tabs.js
// module id = 1721
// module chunks = 6 7 17 18